import { createContext, type ReactNode, use } from 'react';
import type { ApiClient } from './client.ts';

const ApiContext = createContext<ApiClient | null>(null);

export const ApiProvider = ({
  client,
  children,
}: {
  readonly client: ApiClient;
  readonly children: ReactNode;
}) => <ApiContext value={client}>{children}</ApiContext>;

/** The API client created by the composition root. */
export const useApi = (): ApiClient => {
  const client = use(ApiContext);
  if (!client) throw new Error('useApi must be used inside <ApiProvider>');
  return client;
};
